import { Magic } from 'magic-sdk';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getMagicLinkClient = () =>
  new Magic(process.env.MAGIC_LINK_PUBLIC_KEY || '');
